import { render, staticRenderFns } from "./riskoylamaraporu.vue?vue&type=template&id=584be06c"
import script from "./riskoylamaraporu.vue?vue&type=script&lang=js"
export * from "./riskoylamaraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports